<template>
  <div>
    <div class="row">
      <div class="col-md-5 mb-4 has-feedback" :class="{'has-success': fnameValid, 'has-error': !fnamePotentiallyValid}">
        First name<br />
        <input type="text" v-model="form_data.fname" class="form-control">
        <small v-if="!fnameValid" class="text-danger">Please enter a valid first name</small>
      </div>
      <div class="col-md-2 has-feedback" :class="{'has-success': mnamiValid, 'has-error': !mnamiPotentiallyValid}">
          Middle Initial<br />
        <input type="text" v-model="form_data.mnami" class="form-control" v-mask="'A'">
        <small v-if="!mnamiValid" class="text-danger">Please enter a valid initial</small>
      </div>
      <div class="col-md-5 has-feedback" :class="{'has-success': lnameValid, 'has-error': !lnamePotentiallyValid}">
          Last name<br />
        <input type="text" v-model="form_data.lname" class="form-control">
        <small v-if="!lnameValid" class="text-danger">Please enter a valid last name</small>
      </div>
    </div>
    <div class="row" v-if="is_company" >
      <div class="col-md-6 has-feedback" :class="{'has-success': companyNameValid, 'has-error': !companyNamePotentiallyValid}">
        Company name<br />
        <input type="text" v-model="form_data.cmp_name" class="form-control">
        <small v-if="!companyNameValid" class="text-danger">Please enter a valid company name</small>
      </div>
    </div>
    <address-form @input="setAddress" @form-state="setAddressValid" ></address-form>
  </div>
</template>

<script>
  import AddressForm from './Signup/AddressForm.vue';
  export default {
    data() {
      return {
        addressValid: false,
        revio_address: {},
        is_company: this.company,
        form_data: {
          fname: '',   // first name
          mnami: '',   // middle initial
          lname: '' ,  // last name,
          cmp_name: '' // company name
        }
      }
    },

    props: {
      'value': {
        required: false,
        default: null
      },
      'company': {
        required:false,
        default: false
      }
    },

    computed: {
      companyNameValid(){
        if (this.form_data.cmp_name === '') { return false }
        return /^[a-zA-Z]+$/.test(this.form_data.cmp_name);
      },
      companyNamePotentiallyValid () {
        if (this.form_data.cmp_name === '') { return true }
        return /^[a-zA-Z]+$/.test(this.form_data.cmp_name);
      },
      fnameValid(){
        if (this.form_data.fname === '') { return false }
        return /^[a-zA-Z]+$/.test(this.form_data.fname) || this.is_company;
      },
      fnamePotentiallyValid () {
        if (this.form_data.fname === '') { return true }
        return /^[a-zA-Z]+$/.test(this.form_data.fname);
      },
      mnamiValid(){
        if (this.form_data.mnami === '') { return true }
        return /^[a-zA-Z]+$/.test(this.form_data.mnami) || this.is_company;
      },
      mnamiPotentiallyValid () {
        if (this.form_data.mnami === '') { return true }
        return /^[a-zA-Z]+$/.test(this.form_data.mnami)
      },
      lnameValid(){
        if (this.form_data.lname === '') { return false }
        return /^[a-zA-Z ]+$/.test(this.form_data.lname) || this.is_company;
      },
      lnamePotentiallyValid () {
        if (this.form_data.lname === '') { return true }
        return /^[a-zA-Z ]+$/.test(this.form_data.lname);
      },
      addressIsValid () {
        return this.addressValid;
      },
      formValid () {
        return this.fnameValid && this.lnameValid && this.mnamiValid && this.addressValid;
      },
      formData () {
        return {...this.form_data, ...this.revio_address};
      }
    },

    methods: {
      setAddressValid(value){
        this.addressValid = value;
      },
      setAddress(address){
        this.revio_address = address;
      }
    },

    components: {
      AddressForm
    },

    watch: {
      formData: {
        handler(new_value, old_value) {
          this.$emit('input', new_value);
        },
        deep: true
      },
      formValid(new_value, old_value) {
        this.$emit('form-state', new_value);
        this.$emit(new_value ? 'form-valid' : 'form-invalid');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// RevioAddress.vue?556f80bc